import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Alert from "@material-ui/lab/Alert";
import Autocomplete from "@material-ui/lab/Autocomplete";
import axios from "axios";
import "date-fns";
import dayjs from "dayjs";
import { Settings } from "luxon";
import { Validate, ValidationGroup } from "mui-validate";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../../utils/setApiUrl";
import DeviceDataService from "../../../services/DeviceService";
import UserDataService from "../../../services/UserService";
import CardReaderService from "../../../services/CardReaderService";
import { useStyles } from "../../styles/useStyles";
import DeviceGroupsService from "../../../services/DeviceGroupsService";
import DeviceUsersService from "../../../services/DeviceUsersService";
import MqttService from "../../../services/MqttService";
import { useMediaQuery } from "@mui/material";
import { styled, ThemeProvider } from "@mui/system";
import { createTheme } from "@mui/material/styles";
import { LocalizationProvider, MobileDateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const theme = createTheme();

Settings.defaultZone = "Asia/Istanbul";

// Style for consistent card height
const StyledCard = styled(Card)({
    height: "100%",
    display: "flex",
    flexDirection: "column",
});

const StyledCardContent = styled(CardContent)({
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    width: "100%",
});

const CustomMobileDateTimePicker = styled(MobileDateTimePicker)({
    "& .MuiInputBase-input.MuiOutlinedInput-input": {
        padding: "8.5px 14px",
    },
    width: "100%",
});

function CardReaderForm() {
    const classes = useStyles();

    const [loc] = React.useState(() => {
        const locData = JSON.parse(localStorage.getItem("loc"));
        if (locData.id !== undefined) {
            return locData.id;
        }
        return locData;
    });

    useEffect(() => {
        retrieveCardData();
        // setTimeout(() => {
        //   retrieveCardEmployee();
        // }, 5000);
        retrieveWriters();
    }, []);

    const [cardData, setCardData] = useState([]);
    const [cardEmployee, setCardEmployee] = useState([]);
    const [cardGroup, setCardGroup] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);

    // Extend reservation state
    const [extendDialogOpen, setExtendDialogOpen] = useState(false);
    const [extendDateTime, setExtendDateTime] = useState(dayjs());
    const [isExtending, setIsExtending] = useState(false);

    const retrieveCardData = () => {
        setIsLoading(true);
        CardReaderService.getAll()
            .then((response) => {
                if (!response.data || response.data.length === 0) {
                    setIsLoading(false);
                    return;
                }
                const message = response.data[0].message;
                const extractedID = parseInt(message.substring(36, 44), 16);
                const extractedGroup = parseInt(message.substring(148, 153), 16);

                // Use Promise.all to handle both requests in parallel
                Promise.all([
                    UserDataService.getOne(extractedID)
                        .then((response) => setCardEmployee(response.data))
                        .catch((e) => {
                            setErrorMessages(
                                "Не може да се зареди информация за потребителя"
                            );
                            setIserror(true);
                            return null;
                        }),
                    DeviceGroupsService.get(extractedGroup)
                        .then((response) => setCardGroup(response.data))
                        .catch((e) => {
                            setErrorMessages("Не може да се зареди информация за групата");
                            setIserror(true);
                            return null;
                        }),
                ]).finally(() => {
                    setCardData(response.data);
                    setIsLoading(false);
                });
            })
            .catch((e) => {
                setErrorMessages(
                    "Не може да се прочете картата. Моля опитайте отново."
                );
                setIserror(true);
                setIsLoading(false);
            });
    };

    // * Writers Dropdown Start
    const [writers, setWriters] = useState([]);

    const retrieveWriters = () => {
        if (loc === "all") {
            DeviceDataService.adminAllWriters()
                .then((response) => {
                    setWriters(response.data);
                })
                .catch((e) => {
                    setErrorMessages(["Cannot load device data"]);
                    setIserror(true);
                });
        } else {
            const locIds = Array.isArray(loc) ? loc : [loc];
            Promise.all(locIds.map((locId) => DeviceDataService.getAllWriters(locId)))
                .then((responses) => {
                    const allWriters = responses.flatMap((response) => response.data);
                    setWriters(allWriters);
                })
                .catch((e) => {
                    setErrorMessages(["Cannot load device data"]);
                    setIserror(true);
                });
        }
    };

    const [writerValue, setWriterValue] = React.useState(writers[0]);
    const [writerInputValue, setWriterInputValue] = React.useState("");

    // * for error handling
    const [iserror, setIserror] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [successMessage, setSuccessMessage] = useState("");

    const saveCard = async () => {
        if (!writerValue) {
            setErrorMessages("Моля изберете записващо устройство!");
            setIserror(true);
            return;
        }

        setIsLoading(true);
        const client = axios.create({
            baseURL: API_URL,
        });

        client
            .post("/readCard", {
                command: "read",
                device: writerValue.mac,
                // device: "58bf2528e2c8",
            })
            .then((response) => {
                console.log(response);
                // We don't need to call retrieveCardData here since it's already called in the setTimeout
                // Just set loading to false after the timeout
                setTimeout(() => {
                    retrieveCardData();
                }, 5000);
            })
            .catch((error) => {
                setIserror(true);
                setErrorMessages("Не беше открита карта или устройството не отговаря!");
                setIsLoading(false);
                console.log(error.response);
            });
    };

    const handleRemoveUserClick = () => {
        if (cardData.length === 0) {
            setErrorMessages("Няма прочетена карта!");
            setIserror(true);
            return;
        }

        // Extract SAP from the latest card reading
        const latestCard = cardData[0];
        const extractedSAP = parseInt(latestCard.message.substring(36, 44), 16);

        setUserToDelete({
            sap: extractedSAP,
            name: cardEmployee.name || `SAP ${extractedSAP}`
        });
        setDeleteDialogOpen(true);
    };

    const handleRemoveUserConfirm = async () => {
        if (!userToDelete) {
            return;
        }

        setIsLoading(true);
        setDeleteDialogOpen(false);

        try {
            // Remove user from all devices using MQTT service
            await MqttService.removeUserEverywhere(userToDelete.sap);

            // Remove all rows from device_users table for this user SAP
            await DeviceUsersService.remove(userToDelete.sap);

            setErrorMessages("");
            setIserror(false);
            // Show success message using Alert instead of alert()
            setTimeout(() => {
                setErrorMessages("Потребителят беше успешно премахнат от всички устройства и от базата данни!");
                setIserror(false);
            }, 100);
        } catch (error) {
            console.error("Error removing user:", error);
            setErrorMessages(
                "Грешка при премахване на потребителя. Моля опитайте отново."
            );
            setIserror(true);
        } finally {
            setIsLoading(false);
            setUserToDelete(null);
        }
    };

    const handleRemoveUserCancel = () => {
        setDeleteDialogOpen(false);
        setUserToDelete(null);
    };

    // Helper function to parse card expiration date and check if it's in the future
    const getCardExpirationDate = (message) => {
        if (!message) return null;
        const year = message.substring(55, 59);
        const month = message.substring(59, 61);
        const day = message.substring(61, 63);
        const hour = message.substring(63, 65);
        const minute = message.substring(65, 67);
        return dayjs(`${year}-${month}-${day} ${hour}:${minute}`);
    };

    const isCardDateInFuture = () => {
        if (cardData.length === 0) return false;
        const expirationDate = getCardExpirationDate(cardData[0].message);
        if (!expirationDate || !expirationDate.isValid()) return false;
        return expirationDate.isAfter(dayjs());
    };

    // Extend reservation state - minimum datetime for picker
    const [minExtendDateTime, setMinExtendDateTime] = useState(dayjs());

    // Extend reservation handlers
    const handleExtendClick = () => {
        if (cardData.length === 0) return;

        // Initialize with current card expiration date
        const currentExpiration = getCardExpirationDate(cardData[0].message);
        if (currentExpiration && currentExpiration.isValid()) {
            setMinExtendDateTime(currentExpiration);
            setExtendDateTime(currentExpiration.add(15, 'minutes')); // Default to +15 minutes from expiration
        } else {
            setMinExtendDateTime(dayjs());
            setExtendDateTime(dayjs().minute(15));
        }
        setExtendDialogOpen(true);
    };

    const handleExtendCancel = () => {
        setExtendDialogOpen(false);
    };

    const handleExtendSave = async () => {
        if (!cardEmployee || !cardEmployee.sap) {
            setErrorMessages("Не е намерен потребител за удължаване на резервацията!");
            setIserror(true);
            return;
        }

        // Validate that selected datetime is after current card expiration
        if (!extendDateTime || !extendDateTime.isAfter(minExtendDateTime)) {
            setErrorMessages("Моля изберете дата и час след текущата крайна дата на картата!");
            setIserror(true);
            return;
        }

        setIsExtending(true);

        try {
            // Format as ISO string to preserve the exact datetime without timezone conversion
            const formattedEndDate = extendDateTime.format("YYYY-MM-DDTHH:mm:ss") + "Z";

            await UserDataService.update(cardEmployee.sap, {
                end_date: formattedEndDate,
            });

            setExtendDialogOpen(false);
            setIserror(false);
            setErrorMessages("");
            setSuccessMessage("Резервацията беше успешно удължена до " + extendDateTime.format("YYYY-MM-DD HH:mm") + "!");
        } catch (error) {
            console.error("Error extending reservation:", error);
            setErrorMessages("Грешка при удължаване на резервацията. Моля опитайте отново.");
            setIserror(true);
        } finally {
            setIsExtending(false);
        }
    };

    const isSmallScreen = useMediaQuery("(max-width:600px)");

    return (
        <ThemeProvider theme={theme}>
            <StyledCard className={classes.cardReaderBox}>
                <AppBar position="static" elevation={0} color="primary">
                    <Toolbar className="px-8">
                        <Typography
                            variant="subtitle1"
                            color="inherit"
                            className="flex-1 px-12"
                        >
                            Четене на Карта
                        </Typography>
                    </Toolbar>
                </AppBar>
                <StyledCardContent>
                    <div className="submit-form">
                        <div>
                            {iserror && (
                                <Alert
                                    severity="error"
                                    style={{ marginBottom: "15px" }}
                                    onClose={() => setIserror(false)}
                                >
                                    {errorMessages}
                                </Alert>
                            )}
                            {successMessage && (
                                <Alert
                                    severity="success"
                                    style={{ marginBottom: "15px" }}
                                    onClose={() => setSuccessMessage("")}
                                >
                                    {successMessage}
                                </Alert>
                            )}
                            <ValidationGroup>
                                <form className={classes.cardReaderBoxRoot}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={isSmallScreen ? 12 : 6}>
                                            <Validate
                                                name="writer"
                                                required={[true, "Това поле е задължително!"]}
                                            >
                                                <Autocomplete
                                                    value={writers.mac}
                                                    onChange={(event, newWriterValue) => {
                                                        setWriterValue(newWriterValue);
                                                    }}
                                                    inputValue={writerInputValue}
                                                    onInputChange={(event, writerInputValue) => {
                                                        setWriterInputValue(writerInputValue);
                                                    }}
                                                    id="auto-select writer"
                                                    getOptionLabel={(writers) => writers.name}
                                                    className={classes.textField}
                                                    options={writers}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Записващо устройство"
                                                            variant="outlined"
                                                            size="small"
                                                        />
                                                    )}
                                                />
                                            </Validate>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Button
                                                onClick={saveCard}
                                                variant="contained"
                                                color="primary"
                                                disabled={isLoading || !writerValue}
                                            >
                                                {isLoading ? "Четене..." : "Прочети карта"}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </ValidationGroup>
                            <Grid container spacing={2}>
                                {isLoading ? (
                                    <Grid item xs={12}>
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                padding: "20px",
                                            }}
                                        >
                                            <CircularProgress />
                                            <Typography variant="body1" style={{ marginTop: "10px" }}>
                                                Четене на карта...
                                            </Typography>
                                        </div>
                                    </Grid>
                                ) : (
                                    cardData.map((data) => (
                                        <React.Fragment key={data.id || Math.random()}>
                                            <Grid item xs={12} sm={6}>
                                                <Typography variant="body1">
                                                    {(() => {
                                                        if (
                                                            Number(process.env.REACT_APP_HOTEL_NUMBER) ===
                                                            parseInt(data.message.substring(22, 26), 16)
                                                        ) {
                                                            return (
                                                                <span>
                                                                    Хотел: {process.env.REACT_APP_HOTEL_NAME}
                                                                </span>
                                                            );
                                                        } else {
                                                            return <b>"Грешен номер на хотел"</b>;
                                                        }
                                                    })()}
                                                </Typography>
                                                <Typography variant="body1">
                                                    Стая: {parseInt(data.message.substring(26, 30), 16)}
                                                </Typography>

                                                {(() => {
                                                    if (data.message.substring(44, 46) === "FF") {
                                                        return (
                                                            <>
                                                                <Typography variant="body1">
                                                                    Служител: {cardEmployee.name}
                                                                </Typography>
                                                                <Typography variant="body1">
                                                                    {cardGroup.name
                                                                        ? `Група: ${cardGroup.name}`
                                                                        : null}
                                                                </Typography>
                                                            </>
                                                        );
                                                    } else {
                                                        return (
                                                            <>
                                                                <Typography variant="body1">
                                                                    Гост: {cardEmployee.name}
                                                                </Typography>
                                                                <Typography variant="body1">
                                                                    {cardGroup.name
                                                                    ? `Група: ${cardGroup.name}`
                                                                    : 'Група: Няма зададена група'}
                                                                </Typography>
                                                            </>
                                                        );
                                                    }
                                                })()}
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Typography variant="body1">
                                                    Валидна до: {data.message.substring(55, 59)}/
                                                    {data.message.substring(59, 61)}/
                                                    {data.message.substring(61, 63)}{" "}
                                                    {data.message.substring(63, 65)}:
                                                    {data.message.substring(65, 67)}
                                                </Typography>
                                                <Typography variant="body1">
                                                    Тип карта:
                                                    {(() => {
                                                        if (data.message.substring(44, 46) === "FF") {
                                                            return " Мастър на служител";
                                                        } else {
                                                            return " Клиентска";
                                                        }
                                                    })()}
                                                </Typography>
                                                {(() => {
                                                    if (
                                                        data.message.substring(44, 46) !== "FF" &&
                                                        localStorage.getItem("level") === "super"
                                                    ) {
                                                        return (
                                                            <>
                                                                <Typography variant="body1">
                                                                    #Guest:{" "}
                                                                    {parseInt(
                                                                        data.message.substring(88, 96),
                                                                        16
                                                                    )}
                                                                    {" - "}
                                                                    #Employee:{" "}
                                                                    {parseInt(
                                                                        data.message.substring(96, 104),
                                                                        16
                                                                    )}
                                                                    {" - "}
                                                                    #Master:{" "}
                                                                    {parseInt(
                                                                        data.message.substring(104, 112),
                                                                        16
                                                                    )}
                                                                </Typography>
                                                                <Typography variant="body1">
                                                                    Издадена от:{" "}
                                                                    {parseInt(
                                                                        data.message.substring(79, 87),
                                                                        16
                                                                    )}
                                                                </Typography>
                                                            </>
                                                        );
                                                    } else {
                                                        return null;
                                                    }
                                                })()}
                                            </Grid>
                                        </React.Fragment>
                                    ))
                                )}
                            </Grid>
                            {!isLoading && cardData.length > 0 && localStorage.getItem("level") !== "spa" && (
                                <Grid container spacing={2} style={{ marginTop: "10px" }}>
                                    <Grid item>
                                        <Button
                                            onClick={handleRemoveUserClick}
                                            variant="contained"
                                            disabled={isLoading}
                                            style={{ backgroundColor: "#ff1744", color: "white" }}
                                        >
                                            Премахни от всички устройства
                                        </Button>
                                    </Grid>
                                    {isCardDateInFuture() && (
                                        <Grid item>
                                            <Button
                                                onClick={handleExtendClick}
                                                variant="contained"
                                                color="primary"
                                                disabled={isLoading || isExtending}
                                            >
                                                Удължи резервация
                                            </Button>
                                        </Grid>
                                    )}
                                </Grid>
                            )}
                        </div>
                    </div>
                </StyledCardContent>

                {/* Delete Confirmation Dialog */}
                <Dialog
                    open={deleteDialogOpen}
                    onClose={handleRemoveUserCancel}
                    aria-labelledby="delete-dialog-title"
                    aria-describedby="delete-dialog-description"
                >
                    <DialogTitle id="delete-dialog-title">
                        Потвърждение за премахване
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="delete-dialog-description">
                            Сигурни ли сте, че искате да премахнете потребител "{userToDelete && userToDelete.name}" (ID: {userToDelete && userToDelete.sap}) от всички устройства и от базата данни? Това действие е необратимо.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleRemoveUserCancel} color="primary">
                            Отказ
                        </Button>
                        <Button
                            onClick={handleRemoveUserConfirm}
                            variant="contained"
                            autoFocus
                            style={{ backgroundColor: "#ff1744", color: "white" }}
                        >
                            Премахни
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Extend Reservation Dialog */}
                <Dialog
                    open={extendDialogOpen}
                    onClose={handleExtendCancel}
                    aria-labelledby="extend-dialog-title"
                    maxWidth="xs"
                    fullWidth
                >
                    <DialogTitle id="extend-dialog-title">
                        Удължаване на резервация
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText style={{ marginBottom: "16px" }}>
                            Изберете нова крайна дата и час за резервацията на {cardEmployee && cardEmployee.name}:
                        </DialogContentText>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <CustomMobileDateTimePicker
                                label="Нова крайна дата"
                                value={extendDateTime}
                                onChange={(newValue) => {
                                    // Ensure selected datetime is after card expiration
                                    if (newValue && newValue.isAfter(minExtendDateTime)) {
                                        setExtendDateTime(newValue);
                                    } else {
                                        // If invalid time selected, set to expiration + 15 minutes
                                        setExtendDateTime(minExtendDateTime.add(15, 'minutes'));
                                    }
                                }}
                                ampm={false}
                                minDateTime={minExtendDateTime}
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        variant: "outlined",
                                    },
                                }}
                            />
                        </LocalizationProvider>
                        {extendDateTime && extendDateTime.isAfter(minExtendDateTime) && (
                            <Typography
                                variant="body2"
                                style={{ marginTop: "8px", color: "#4caf50" }}
                            >
                                {(() => {
                                    const diffMs = extendDateTime.diff(minExtendDateTime);
                                    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                                    const diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                                    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

                                    const parts = [];
                                    if (diffDays > 0) parts.push(`${diffDays} ${diffDays === 1 ? 'ден' : 'дни'}`);
                                    if (diffHours > 0) parts.push(`${diffHours} ${diffHours === 1 ? 'час' : 'часа'}`);
                                    if (diffMinutes > 0) parts.push(`${diffMinutes} ${diffMinutes === 1 ? 'минута' : 'минути'}`);

                                    return parts.length > 0
                                        ? `Удължаване с: ${parts.join(', ')}`
                                        : 'Няма промяна';
                                })()}
                            </Typography>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleExtendCancel} color="primary" disabled={isExtending}>
                            Отказ
                        </Button>
                        <Button
                            onClick={handleExtendSave}
                            variant="contained"
                            color="primary"
                            disabled={isExtending || !extendDateTime || !extendDateTime.isAfter(minExtendDateTime)}
                        >
                            {isExtending ? "Запазване..." : "Запази"}
                        </Button>
                    </DialogActions>
                </Dialog>
            </StyledCard>
        </ThemeProvider>
    );
}

export default CardReaderForm;
